import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { images } from '../data/content';
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-169" data-mp="ei1xdrp9qd0l">
      <div className="mx-auto max-w-4xl text-center" data-id="element-170" data-mp="9ll8uwe5pwmz">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-171" data-mp="4lqfmm6wsuyr">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-ink font-serif text-lg font-bold text-gold" data-id="element-172" data-mp="4jm6npu5l5rm">
            S
          </span>
          <span className="font-serif text-lg font-bold text-ink" data-id="element-173" data-mp="xbfmvha7pr8t">Sculptor’s Operating Blueprint™</span>
        </div>
        <p className="mx-auto mt-3 inline-block rounded-full border border-gold/50 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-gold-dark" data-id="element-174" data-mp="s9q6dm480ldc">
          For plastic surgeons & otolaryngologists
        </p>

        <h1 className="mt-6 font-serif text-[2.35rem] font-bold leading-[1.08] text-ink sm:text-6xl" data-id="element-175" data-mp="3cz5ug9c21vza">
          Structure Your Next Rhinoplasty Case in{' '}
          <em className="italic text-gold-dark" data-id="element-176" data-mp="3j9u1d0dmvqmc">15 Minutes</em>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-177" data-mp="3o85af8w3tx3i">
          A visual step-by-step planning system to organize case analysis, surgical objectives, preparation, and
          post-case review — without digging through scattered notes, courses, or reference materials. Includes{' '}
          <strong className="text-ink" data-id="element-178" data-mp="30h9cdu1225nt">6 premium volumes</strong>, <strong className="text-ink" data-id="element-179" data-mp="358rfooqjwiby">5 professional tools</strong>{' '}
          and <strong className="text-ink" data-id="element-180" data-mp="35audhuxy3fr8">30+ planning frameworks</strong>.
        </p>

        <img src={images.mockup} alt="Sculptor’s Operating Blueprint 6 volumes, worksheets, tablet and planning book" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-181" data-mp="2qloh0eqhs3n1" />

        <div className="mx-auto mt-4 max-w-xl" data-id="element-182" data-mp="2hjyo14gyown5">
          <CTAButton id="first-cta" label="I want the Sculptor’s Blueprint" data-id="element-183" data-mp="2lla4okhuy7j7" />
          <p className="mt-3 text-sm text-muted" data-id="element-184" data-mp="s21gc6a6u3xc">
            Instant digital access · One-time payment of <strong className="text-ink" data-id="element-185" data-mp="nbbcwylbob5a">$27</strong> · Lifetime access ·
            7-day guarantee
          </p>
        </div>

        <div className="mt-8" data-id="element-186" data-mp="ibow6f6accrq">
          <Countdown data-id="element-187" data-mp="icromrj9an9r" />
          <p className="mt-1 text-xs text-muted" data-id="element-188" data-mp="ia5kz2zhkrwt">The currency conversion is automatically adjusted according to your country.</p>
        </div>
      </div>
    </header>;
}